export const SUBURBS_DETAILED = [
  {
    slug: "woodvale",
    name: "Woodvale",
    region: "Perth's northern suburbs",
    img: "/images/grab-01.jpg",
    alt: "Grab rail installed in a Perth bathroom to improve safety and support at home",
    blurb: "Modify supplies and professionally installs grab rails, hand rails and rubber ramps for homeowners across Woodvale and Perth's northern suburbs. Simple solutions, careful installation, and a local team that genuinely cares.",
  },
  {
    slug: "joondalup",
    name: "Joondalup",
    region: "Perth's northern suburbs",
    img: "/images/grab-08.jpg",
    alt: "Grab rail installed in a Joondalup bathroom to improve home safety",
    blurb: "From bathroom grab rails to practical rubber ramps, Modify helps Joondalup households make everyday living safer — with professional installation across the northern suburbs.",
    recent: "Recent work includes grab rail installations in Joondalup bathrooms.",
  },
  {
    slug: "wanneroo",
    name: "Wanneroo",
    region: "Perth's northern suburbs",
    img: "/images/hand-02.jpg",
    alt: "Custom handrail installation at a Perth home entrance",
    blurb: "Modify provides grab rails, hand rails and rubber ramps — supplied and professionally installed — for homes across Wanneroo and the surrounding northern corridor.",
  },
  {
    slug: "hillarys",
    name: "Hillarys",
    region: "Perth's northern coastal suburbs",
    img: "/images/grab-11.jpg",
    alt: "Drop-down support rail supplied and installed in Hillarys, Perth",
    blurb: "Making everyday living safer in Hillarys with professionally installed grab rails, hand rails and rubber ramp solutions tailored to your home.",
    recent: "Recent work includes a drop-down support rail supplied and installed in Hillarys.",
  },
  {
    slug: "duncraig",
    name: "Duncraig",
    region: "Perth's northern suburbs",
    img: "/images/hand-05.jpg",
    alt: "Stainless steel handrail fitted for everyday support in Perth",
    blurb: "Modify supplies and installs grab rails, hand rails and rubber ramps across Duncraig — practical safety solutions installed with care.",
  },
  {
    slug: "balcatta",
    name: "Balcatta",
    region: "Perth's northern suburbs",
    img: "/images/grab-10.jpg",
    alt: "Professional grab rail installation in a Balcatta home bathroom",
    blurb: "Grab rails, hand rails and rubber ramps supplied and professionally installed for Balcatta homes — simple solutions that help you move confidently at home.",
    recent: "Recent work includes professional grab rail installation in a Balcatta bathroom.",
  },
  {
    slug: "morley",
    name: "Morley",
    region: "Perth's north-eastern suburbs",
    img: "/images/grab-09.jpg",
    alt: "Grab rails installed in a Morley bathroom to reduce fall risk at home",
    blurb: "Modify helps Morley households feel safer at home with grab rails, hand rails and rubber ramps — supplied and professionally installed by a local Perth team.",
    recent: "Recent work includes grab rails and mobility rubber ramps installed in Morley.",
  },
  {
    slug: "midland",
    name: "Midland",
    region: "Perth's eastern suburbs",
    img: "/images/ramp-03.jpg",
    alt: "Rubber ramp solution installed for a small step in Perth",
    blurb: "From grab rails in the bathroom to rubber ramps at the entry, Modify supplies and installs practical safety solutions across Midland and Perth's east.",
  },
  {
    slug: "canning-vale",
    name: "Canning Vale",
    region: "Perth's southern suburbs",
    img: "/images/hand-07.jpg",
    alt: "Modular handrail supplied and installed at a Perth residence",
    blurb: "Modify supplies and professionally installs grab rails, hand rails and rubber ramps for Canning Vale homes — making everyday access safer and easier.",
  },
  {
    slug: "baldivis",
    name: "Baldivis",
    region: "Perth's southern suburbs",
    img: "/images/ramp-10.jpg",
    alt: "Ramp installed in Baldivis, Perth, Western Australia",
    blurb: "Practical grab rail, hand rail and rubber ramp solutions for Baldivis households — supplied and installed by Modify, Perth's specialist safety installation team.",
    recent: "Recent work includes a ramp installation in Baldivis.",
  },
  {
    slug: "mandurah",
    name: "Mandurah",
    region: "south of Perth",
    img: "/images/ramp-01.jpg",
    alt: "Rubber ramp installed in Mandurah, Perth, Western Australia",
    blurb: "Modify supplies and installs grab rails, hand rails and rubber ramps across Mandurah — helping locals feel more confident and independent at home.",
    recent: "Recent work includes rubber ramp installations in Mandurah.",
  },
  {
    slug: "alkimos",
    name: "Alkimos",
    region: "Perth's far northern coastal suburbs",
    img: "/images/ramp-08.jpg",
    alt: "Rubber ramp supplied and installed in Alkimos, Perth",
    blurb: "Grab rails, hand rails and rubber ramps supplied and professionally installed in Alkimos and Perth's far northern suburbs — simple solutions, professionally installed.",
    recent: "Recent work includes a rubber ramp supplied and installed in Alkimos.",
  },
  {
    slug: "jolimont",
    name: "Jolimont",
    region: "Perth's western suburbs",
    img: "/images/hand-11.jpg",
    alt: "Handrail supplied and fitted in Jolimont, Western Australia",
    blurb: "Modify brings specialist grab rail, hand rail and rubber ramp installation to Jolimont and Perth's western suburbs — thoughtful solutions for safer everyday living.",
    recent: "Recent work includes a handrail supplied and fitted in Jolimont.",
  },
];
